import React from "react"
import clockMarkers from "../clockMarkers"

function TimeAndTemp(props) {
    const markers = clockMarkers.map((value, index) => {
        return (
            <div key={index }className={"numberMarkerWrapper " + value}>
                <div className="numberMarker numberMarkerTop stopWatchColor"></div>
                <div className="numberMarker numberMarkerBottom stopWatchColor"></div>    
            </div>
        )
    })
    
    const dots = [
        "dotRowOne",
        "dotRowOne",
        "dotRowOne",
        "dotRowOne specialDot",
        "dotRowTwo specialDot",
        "dotRowTwo",
        "dotRowTwo",
        "dotRowTwo",
        "dotRowThree",
        "dotRowThree specialDot",
        "dotRowThree",
        "dotRowThree",
        "dotRowFour",
        "dotRowFour specialDot",
        "dotRowFour",
        "dotRowFour"
    ]
    
    const temperatureDots = dots.map((value, index) => {
        return  <div key={index} className={"temperatureDot " + value}></div>
    })
    
    return (
        <div className="analysisSlot">
            <div className="stopWatchWrapper">
                <div className="stopWatchSizing">
                    <div className="clockWrapper stopWatchColor">
                        <div className="clockInner"></div>
                        {markers}

                        <div className="numberMarkerWrapper fourJokersRotate" id="secondHandRotate">
                            <div className="clockHand minuteHand fourJokersHand stopWatchColor"></div>
                        </div>

                        <div className="middleDot"></div>

                    </div>
                </div>
            </div>

            <h2 className="stopWatchTime">{props.currentSeconds + " secs"}</h2>
        
            <div className="temperatureVisual">
                {temperatureDots}
            </div>
        
            <h2 className="temperatureReadOut">{props.currentTemp + " degrees"}</h2>
        </div>
    )
}

export default TimeAndTemp